import { Component, Input, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './login-accordion.content.json';

/**
 * @ngdoc component
 * @name LoginAccordionComponent
 * @module LoginAccordionModule
 */
@Component({
    selector: 'klant-login-accordion',
    templateUrl: './login-accordion.component.html',
    standalone: false
})
export class LoginAccordionComponent implements OnInit {
    @Input()
    public redirect: boolean;

    public variant: 'redirect' | 'default';

    public constructor(private readonly contentService: ApContentService) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.variant = this.redirect ? 'redirect' : 'default';
    }

    public hasContentItems(): boolean {
        const inputs: string[] = [
            `klant.login.accordion.${this.variant}.item-1.title`,
            `klant.login.accordion.${this.variant}.item-2.title`,
            `klant.login.accordion.${this.variant}.item-3.title`,
            `klant.login.accordion.${this.variant}.item-4.title`
        ];
        return inputs.some((input) => this.hasContent(input));
    }

    private hasContent(item: string): boolean {
        const text = this.contentService.get(item);
        return text.trim() !== '';
    }
}
